import { FormFieldTypes } from '@/types/types';
import { useTranslation } from 'react-i18next';
import { usePhoneNumberManager } from '@hero/web-hooks';
import { CustomFormField } from '@hero/web-components';
import { Spinner } from '@hero/web-components';
import { Button } from '@hero/web-components';
import { Form } from '@hero/web-components';

export default function RegistrationPhoneForm() {
  const { t } = useTranslation(['registration']);
  const { form, isPending, onSubmit } = usePhoneNumberManager();

  return (
    <Form {...form}>
      <form onSubmit={onSubmit} className="w-full pt-7">
        <CustomFormField
          control={form.control}
          filedType={FormFieldTypes.PHONE_INPUT}
          name="phone"
          placeholder={t('registration:phoneNumberPlaceholder')}
        />

        <Button
          type="submit"
          disabled={isPending}
          className="w-full mt-6 h-13 rounded-[32px] text-[16px] leading-[26px] font-[500]">
          {isPending ? <Spinner /> : t('registration:registerBtn')}
        </Button>
      </form>
    </Form>
  );
}
